export default __webpack_public_path__ + "static/media/DNase_Free_Water.63c0b17a.svg";